import React from "react";
import { PageShell } from "./PageShell";
import { PageIntro } from "../components/PageIntro";
import { Products } from "../components/sections/Products";
import { HowItWorks } from "../components/sections/HowItWorks";
import { Geography } from "../components/sections/Geography";

export default function ProductsPage() {
  return (
    <PageShell>
      <div className="pt-[72px]">
        <PageIntro contentKey="products" />
        <Products hideIntro />
        <HowItWorks />
        <Geography />
      </div>
    </PageShell>
  );
}
